import produce from 'immer';

import {
  CE_LIBRARY_URL_FETCH_FAILURE,
  CE_LIBRARY_URL_FETCH_REQUEST,
  CE_LIBRARY_URL_FETCH_SUCCESS,
} from '@actions/ceLibraryUrl';
import {} from '@actions/municipalCode';

const initialState: ICeLibraryUrlStore = {
  isCeLiraryUrlActive: false,
  codeEnforcementLibraryUrl: null,
  error: null,
};

export default (state: ICeLibraryUrlStore = initialState, action: any) =>
  produce(state, (draftState: ICeLibraryUrlStore) => {
    switch (action.type) {
      case CE_LIBRARY_URL_FETCH_REQUEST:
        draftState.error = null;

        return;
      case CE_LIBRARY_URL_FETCH_SUCCESS:
        draftState.codeEnforcementLibraryUrl = action.response.codeEnforcementLibraryUrl;
        draftState.isCeLiraryUrlActive = action.response.isCeLiraryUrlActive;
        draftState.error = null;

        return;
      case CE_LIBRARY_URL_FETCH_FAILURE:
        draftState.codeEnforcementLibraryUrl = null;
        draftState.isCeLiraryUrlActive = false;
        draftState.error = action.error;

        return;
    }
  });
